'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base/Base');

var _Base2 = _interopRequireDefault(_Base);

var _Tooltip = require('../Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipContent = require('../Tooltip/TooltipContent');

var _TooltipContent2 = _interopRequireDefault(_TooltipContent);

var _TooltipContext = require('../Tooltip/TooltipContext');

var _TooltipContext2 = _interopRequireDefault(_TooltipContext);

var _TooltipSource = require('../Tooltip/TooltipSource');

var _TooltipSource2 = _interopRequireDefault(_TooltipSource);

var _TooltipTarget = require('../Tooltip/TooltipTarget');

var _TooltipTarget2 = _interopRequireDefault(_TooltipTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function elementHasEllipsis() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var current = ref.current;

  return current && current.scrollWidth > current.clientWidth;
}

var EllipsisTooltip = function (_Component) {
  _inherits(EllipsisTooltip, _Component);

  function EllipsisTooltip(props) {
    _classCallCheck(this, EllipsisTooltip);

    var _this = _possibleConstructorReturn(this, (EllipsisTooltip.__proto__ || Object.getPrototypeOf(EllipsisTooltip)).call(this, props));

    _this.state = {
      hasEllipsis: false
    };

    _this.container = _react2.default.createRef();

    _this.updateTooltipEnabled = _this.updateTooltipEnabled.bind(_this);
    return _this;
  }

  _createClass(EllipsisTooltip, [{
    key: 'updateTooltipEnabled',
    value: function updateTooltipEnabled() {
      var hasEllipsis = elementHasEllipsis(this.container);

      if (this.state.hasEllipsis !== hasEllipsis) {
        this.setState({ hasEllipsis: hasEllipsis });
      }
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.updateTooltipEnabled();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          delay = _props.delay,
          width = _props.width,
          theme = _props.theme,
          rest = _objectWithoutProperties(_props, ['children', 'color', 'delay', 'width', 'theme']);

      var hasEllipsis = this.state.hasEllipsis;


      if (!hasEllipsis) {
        return _react2.default.createElement(
          _Base2.default,
          _extends({ baseRef: this.container, textEllipsis: true }, rest, { onMouseOver: this.updateTooltipEnabled }),
          children
        );
      }

      return _react2.default.createElement(
        _Tooltip2.default,
        { delay: delay, enabled: true },
        _react2.default.createElement(
          _TooltipTarget2.default,
          null,
          _react2.default.createElement(
            _Base2.default,
            _extends({ baseRef: this.container, textEllipsis: true }, rest),
            children
          )
        ),
        _react2.default.createElement(
          _TooltipSource2.default,
          { theme: theme, width: width },
          _react2.default.createElement(
            _TooltipContext2.default,
            { color: color },
            _react2.default.createElement(
              _TooltipContent2.default,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return EllipsisTooltip;
}(_react.Component);

EllipsisTooltip.propTypes = {
  children: _propTypes2.default.node,
  color: _propTypes2.default.oneOf(['carbon', 'white']),
  delay: _propTypes2.default.bool,
  theme: _propTypes2.default.oneOf(['day', 'night']),
  width: _propTypes2.default.string
};
EllipsisTooltip.defaultProps = {
  color: 'carbon',
  delay: true,
  theme: 'night',
  width: 'auto'
};
exports.default = EllipsisTooltip;